__turbopack_context__.v({
  "body": "handbookWaitlistPrompt-module-scss-module__IzsCeq__body",
  "link": "handbookWaitlistPrompt-module-scss-module__IzsCeq__link",
  "prompt": "handbookWaitlistPrompt-module-scss-module__IzsCeq__prompt",
  "title": "handbookWaitlistPrompt-module-scss-module__IzsCeq__title",
});
